import { render, staticRenderFns } from "./pcpage.vue?vue&type=template&id=27c8a617&scoped=true&"
import script from "./pcpage.vue?vue&type=script&lang=js&"
export * from "./pcpage.vue?vue&type=script&lang=js&"
import style0 from "./pcpage.vue?vue&type=style&index=0&lang=css&"
import style1 from "./pcpage.vue?vue&type=style&index=1&id=27c8a617&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27c8a617",
  null
  
)

export default component.exports